// extracted by mini-css-extract-plugin
module.exports = {"select":"styles__select___35xAm","select--error":"styles__select--error___2aSMu"};